export const file_picker_callback = async (cb, _value, meta) => {
    if (meta.filetype !== 'media') return

    const input = document.createElement('input')
    input.type = 'file'
    input.accept = 'video/*'
    input.onchange = async () => {
        const file = input.files[0]
        const blobInfo = window.tinymce.activeEditor.editorUpload.blobCache.create(
            file.name, file, file.type
        )

        try {
            const handler = window.tinymce.activeEditor.getParam('media_upload_handler')
            const url = await handler(blobInfo)
            cb(url, {source2: '', poster: ''})
        } catch (e) {
            window.tinymce.activeEditor.notificationManager.open({
                text: e.message || 'Upload error',
                type: 'error'
            })
        }
    }
    input.click()
}